/* eslint-disable ember/classic-decorator-hooks, ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import { service } from '@ember/service';

export default class PageRoute extends Route {
  // Services
  @service
  router;

  @service
  store;

  model(params) {
    let store = this.store;
    let group = this.modelFor('group');

    return hash({
      page: store.findRecord('posts/page', params.page_id),
      group,
    });
  }

  afterModel(model) {
    // grab the assessments linked to the page in question after it has
    // resolved so we can obtain the linked assessment IDs.
    let assessmentIds;
    let assessments = model.page.assessment_ids;
    if (assessments.length > 0) {
      // assessments is a fragment array: spread it, or stringify reaches the store.
      assessmentIds = JSON.stringify([...assessments]);
    }

    model.assessments = this.store.query('assessments/assessment', {
      assessmentIds,
    });
    return hash(model);
  }

  init() {
    super.init(...arguments);

    this.router.on('routeDidChange', (transition) => {
      if (transition.to.find((route) => route.name === this.routeName)) {
        // Set activeAssessment on the controller so that it can highlight the correct button.
        let assessmentId = this.paramsFor(
          'group.page.assessment',
        ).assessment_id;
        this.controller.set('activeAssessment', assessmentId);
      }
    });
  }
}
